import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'arrayToString'
})
export class ArrayToStringPipe implements PipeTransform {
	transform(input: any, sep = ' | '): string {
		const name: string[] = [];
		input?.forEach((s: any) => name.push(s.nombre));
		return name.join(sep);
	}
}
